import { defineComponent as _defineComponent } from 'vue'
import { computed } from '@nuxtjs/composition-api';
import { AccessStatus } from '~/src/domain/entities/schema';

interface Props {
  status: AccessStatus;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'LoginStatusLabel',
  props: {
    status: null
  },
  setup(__props: any) {

const props = __props as {
  status: AccessStatus;
};

const getLabelStyle = (status: AccessStatus) =>
  status === 'enter' ? 'background: #00A5EF;' : 'background: #757575;';
const getLabelText = (status: AccessStatus) => (status === 'enter' ? '入室中' : '退室中');



const style = computed(() => getLabelStyle(props.status));
const text = computed(() => getLabelText(props.status));

return { __sfc: true,getLabelStyle, getLabelText, props, style, text }
}

})